<template>
  <component :is="wrapInAppContent ? 'app-content' : 'div'">
    <app-content-body>

      <div class="inner" v-if="!tvStationId">
        <p class="buttons">
          <a
              class="btn btn_action btn_add"
              title="Přidat kanál"
              @click.prevent="createItem"
          >Přidat kanál</a>
        </p>
        <h1 v-translate>TV kanály</h1>
      </div>

      <app-table
          clickable
          :data="items"
          :highlight-rows-on-hover="true"
          :order="params.order"
          :page-size="params.limit"
          @sort="localSortItems"
          @rowClick="goToDetail"
          @deleteRow="deleteItem"
          :loading="listLoading"
          :image-cell="true"
      >
        <template slot="header">
          <app-table-header-item class="field_left">
            <app-input
                type="search"
                :label="translations.search"
                v-model="params.search"
                @input="fetchItems(true)"
            />
          </app-table-header-item>
          <app-table-header-item class="field_right">
            <app-table-header-select :label="translations.active">
              <app-select
                  :options="activeSelect"
                  v-model.trim="params.active"
                  @change="fetchItems(true)"
              />
            </app-table-header-select>
          </app-table-header-item>
        </template>

        <app-table-column first sortable attribute="name" :label="translations.name">
          <template slot-scope="row">
            <strong>
              {{ row.name }}
            </strong>
          </template>
        </app-table-column>
        <app-table-column sortable attribute="_id" :label="translations.tvChannelId" />
        <app-table-column sortable attribute="tvStation" :label="translations.tvStation">
          <template slot-scope="row">
            {{ row.tvStation && row.tvStation.name }}
          </template>
        </app-table-column>
        <app-table-column :image-cell="true" :label="translations.logo">
          <template slot-scope="row">
            <img class="tv-channels-img" v-if="row.channelLogoDefaultExists" :src="getImageLink(row)" :alt="translations.tvStationLogo">
          </template>
        </app-table-column>
        <app-table-column sortable attribute="active" :label="translations.active">
          <template slot-scope="row">
            <app-graphic-image
                :value="row.active"
            />
          </template>
        </app-table-column>
          <app-table-column sortable attribute="weight" :label="translations.weight">
              <template slot-scope="row">
                  {{ row.weight }}
              </template>
          </app-table-column>
          <app-table-column :label="translations.lastImport">
              <template slot-scope="row">
                  <div v-html="formatDate(row._lastImport)" />
              </template>
          </app-table-column>
        <app-table-column sortable attribute="updated" :label="translations.updated">
          <template slot-scope="row">
            <div v-html="formatDate(row._updated)" />
          </template>
        </app-table-column>

        <template slot="footer" v-if="itemsMetadata.totalCount > params.limit">
          <app-table-pagination
              :page="listPage"
              :itemsPerPage="params.limit"
              :totalCount="itemsMetadata.totalCount"
              @pageChanged="tablePageChanged"
          />
        </template>
      </app-table>
    </app-content-body>
  </component>
</template>

<script>
import getItemsListMixin from 'mixins/getItemsListMixin'
import appTitleMixin from 'mixins/appTitleMixin'
import formatDateMixin from 'mixins/formatDateMixin'
import { mapActions } from 'vuex'

const itemsListMixin = getItemsListMixin({
  apiMethodsSuffix: 'TvChannels',
  enumsMap: true
})

export default {
  name: 'tv-channels',
  preventFetchOnCreated: true,
  mixins: [formatDateMixin, itemsListMixin, appTitleMixin()],
  methods: {
    ...mapActions([
      'getTvChannels'
    ]),
    shouldRefreshOnCreate() {
      return false
    },
    localSortItems(order) {
      this.params.tvStationId = this.tvStationId
      this.sortItems(order)
    },
    goToDetail(item) {
      this.$router.push({
        name: 'tv-channel',
        params: { id: item._id }
      })
    }
  },
  computed: {
    translations() {
      return {
        search: this.$gettext('Vyhledávání'),
        name: this.$gettext('Název'),
        tvChannelId: this.$gettext('ID TV kanálu'),
        tvStation: this.$gettext('TV Stanice'),
        logo: this.$gettext('Logo'),
        tvStationLogo: this.$gettext('Logo TV stanice'),
        updated: this.$gettext('Upraveno'),
        active: this.$gettext('Aktivní'),
        weight: this.$gettext('Váha'),
        lastImport: this.$gettext('Poslední import')
      }
    },
    activeSelect() {
      return [
        { name: this.$gettext('Nevybráno'), value: null },
        { name: this.$gettext('Ano'), value: true },
        { name: this.$gettext('Ne'), value: false }
      ]
    },
    currentTitle() {
      return [
        this.$gettext('TV kanály')
      ]
    },
    getImageLink() {
      return value => {
        return value.channelLogoDir + '/channel_logos/' + value._id + '.png' + '?t=' + Date.now()
      }
    }
  },
  created() {
    const tvStationId = this.tvStationId
    this.getTvChannels({ params: { tvStationId: tvStationId } })
  },
  props: {
    tvStationId: {
      type: Number,
      required: false
    },
    wrapInAppContent: {
      type: Boolean,
      required: false,
      default: true
    }
  }
}
</script>
